import { render, staticRenderFns } from "./NbFooter.vue?vue&type=template&id=f5f11a62&scoped=true&"
import script from "./NbFooter.vue?vue&type=script&lang=js&"
export * from "./NbFooter.vue?vue&type=script&lang=js&"
import style0 from "./NbFooter.vue?vue&type=style&index=0&id=f5f11a62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f11a62",
  null
  
)

export default component.exports